import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'María González',
      location: 'Eixample, Barcelona',
      rating: 5,
      text: 'Excelente servicio. Vaciaron el piso de mi madre en un día y dejaron todo impecable. El equipo fue muy profesional y respetuoso. Totalmente recomendable.',
      date: 'Hace 2 semanas'
    },
    {
      name: 'Carlos Martínez',
      location: 'Gràcia, Barcelona',
      rating: 5,
      text: 'Contraté a VPB para vaciar un piso de herencia. El precio fue justo y transparente, sin sorpresas. Gestionaron todo de forma responsable y rápida. Muy satisfecho con el resultado.',
      date: 'Hace 1 mes'
    },
    {
      name: 'Laura Sánchez',
      location: 'Sants, Barcelona',
      rating: 5,
      text: 'Necesitaba vaciar mi piso urgentemente y VPB respondió en menos de 24 horas. El equipo fue eficiente, cuidadoso y muy amable. Sin duda los volvería a contratar.',
      date: 'Hace 3 semanas'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            La satisfacción de nuestros clientes es nuestra mejor carta de presentación. Lee sus experiencias reales con nuestro <a href="#servicios" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">servicio de vaciado de pisos</a>.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto px-8 sm:px-12">
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-6 sm:p-8 md:p-12">
            <div className="flex items-center justify-center mb-4 sm:mb-6">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-xl sm:text-2xl text-yellow-400"></i>
              ))}
            </div>

            <blockquote className="text-center mb-6 sm:mb-8">
              <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-4 sm:mb-6 px-2">
                "{testimonials[currentIndex].text}"
              </p>
            </blockquote>

            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-user-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-base sm:text-lg font-semibold text-gray-900">
                {testimonials[currentIndex].name}
              </h4>
              <p className="text-xs sm:text-sm text-gray-600 mb-1">
                {testimonials[currentIndex].location}
              </p>
              <p className="text-xs text-gray-500">
                {testimonials[currentIndex].date}
              </p>
            </div>
          </div>

          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer"
            aria-label="Testimonio anterior"
          >
            <i className="ri-arrow-left-s-line text-xl sm:text-2xl"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer"
            aria-label="Siguiente testimonio"
          >
            <i className="ri-arrow-right-s-line text-xl sm:text-2xl"></i>
          </button>

          <div className="flex items-center justify-center gap-2 sm:gap-3 mt-6 sm:mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex
                    ? 'bg-teal-600 w-6 sm:w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Ir al testimonio ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-base sm:text-lg text-gray-600 mb-6 px-4">
            ¿Quieres ser nuestro próximo cliente satisfecho? <a href="#contacto" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">Contáctanos ahora</a> y descubre por qué somos la mejor opción para el vaciado de pisos en Barcelona.
          </p>
        </div>
      </div>
    </section>
  );
}
